import { getApiSource } from './url';

// Path substrings to ignore from API error tracking, keyed by apiSource.
// Add an entry here for any endpoint whose failures are expected/noisy
// and shouldn't pollute the GA "API-error" event stream.
export const IGNORE_API_LIST: Record<string, string[]> = {
  eshop: [
    //API endpoints that are expected to false positive and should not be tracked
    '/logout',
    '/delete'
  ]
};

export const shouldSuppressApiErrorTracking = (requestUrl: string): boolean => {
  try {
    if (!requestUrl) return false;

    const apiSource = getApiSource(requestUrl);
    const ignoredPaths = IGNORE_API_LIST[apiSource];
    if (!ignoredPaths?.length) return false;

    const { pathname } = new URL(requestUrl, 'https://tracking.invalid');
    return ignoredPaths.some(ignoredPath => pathname.includes(ignoredPath));
  } catch {
    // Suppression must never throw and change the application flow.
    return false;
  }
};
